import { RouteRecordRaw } from 'vue-router'
import Layout from '@/layout/Index.vue'

const  limitedRouter: Array<RouteRecordRaw> = [
    {
        path: '/limited',
        name: '限量管理',
        component: Layout,
        meta: { title: '限量管理', icon: 'icon-lock', alwaysShow: true },
        children: [
            {
                path: 'brand',
                name: '品牌限量管理',
                component: () => import('@/views/limited/BrandLimited.vue'),
                meta: { title: '品牌限量管理' }
            },
            {
                path: 'cat',
                name: '三级分类限量管理',
                component: () => import('@/views/limited/CatLimited.vue'),
                meta: { title: '三级分类限量管理' }
            },
        ]
    }
]

export default  limitedRouter